// removed by extract-text-webpack-plugin
module.exports = {"TabTable":"TabTable","NavTab":"NavTab","DetailButton":"DetailButton","nav-item":"nav-item","ActiveTab":"ActiveTab","nav-link":"nav-link","active":"active","SimpleNavBar":"SimpleNavBar","TabContent":"TabContent","tab-pane":"tab-pane"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/TabTable/styles.scss
// module id = 1977
// module chunks = 10